import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface ClienteDetalhes {
  // Campos principais do PacienteClinica (em lowercase)
  id_paciente_clinica?: number;
  id_empresa?: number;
  id_usuario?: number;
  email?: string;
  nome?: string;
  data_cadastro?: Date;
  cpf?: string;
  data_nascimento?: Date;
  id_cidade?: number;
  rua?: string;
  bairro?: string;
  complemento?: string;
  cep?: string;
  numero?: string;
  telefone_residencial?: string;
  telefone_celular?: string;
  rg?: string;
  carteira?: string;
  dante_causa?: string;
  genero?: number;
  telefone_adicional?: string;
  observacoes?: string;
  nome_mae?: string;
  nome_pai?: string;
  arvore?: string;
  link_pasta?: string;
  sharepoint?: string;
  pasta_fisica?: boolean;
  
  // Campos NotMapped para formulário
  senha?: string;
  
  // Campos adicionais para interface
  pais?: string;
  estado?: string;
  cidade?: string;
}

@Component({
  selector: 'app-modal-visualizar-cliente',
  templateUrl: './modal-visualizar-cliente.component.html',
  styleUrls: ['./modal-visualizar-cliente.component.scss']
})
export class ModalVisualizarClienteComponent implements OnInit {

  @Input() isVisible: boolean = false;
  @Input() clienteDetalhes: ClienteDetalhes | null = null;
  @Output() modalClosed = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.isVisible && this.clienteDetalhes) {
      // Modal foi aberto com dados do cliente
    }
  }

  fecharModal(): void {
    this.isVisible = false;
    this.modalClosed.emit(false);
  }

  // Métodos auxiliares para formatação
  formatarData(data: Date | string | undefined): string {
    if (!data) return 'Não informado';
    const date = new Date(data);
    return date.toLocaleDateString('pt-BR');
  }

  formatarTelefone(telefone: string | undefined): string {
    if (!telefone) return 'Não informado';
    return telefone;
  }

  formatarGenero(genero: number | undefined): string {
    if (!genero) return 'Não informado';
    switch (genero) {
      case 1: return 'Masculino';
      case 2: return 'Feminino';
      case 3: return 'Outro';
      default: return 'Não informado';
    }
  }

  formatarBoolean(valor: boolean | undefined): string {
    if (valor === undefined) return 'Não informado';
    return valor ? 'Sim' : 'Não';
  }

  obterEnderecoCompleto(): string {
    if (!this.clienteDetalhes) return 'Não informado';
    
    const endereco = [];
    if (this.clienteDetalhes.rua) endereco.push(this.clienteDetalhes.rua);
    if (this.clienteDetalhes.numero) endereco.push(this.clienteDetalhes.numero);
    if (this.clienteDetalhes.complemento) endereco.push(this.clienteDetalhes.complemento);
    if (this.clienteDetalhes.bairro) endereco.push(this.clienteDetalhes.bairro);
    if (this.clienteDetalhes.cep) endereco.push(this.clienteDetalhes.cep);
    if (this.clienteDetalhes.cidade) endereco.push(this.clienteDetalhes.cidade);
    if (this.clienteDetalhes.estado) endereco.push(this.clienteDetalhes.estado);
    if (this.clienteDetalhes.pais) endereco.push(this.clienteDetalhes.pais);
    
    return endereco.length > 0 ? endereco.join(', ') : 'Não informado';
  }
}
